import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import AboutSection from "../../components/AboutComponents/AboutSection/AboutSection";
import BrandSection from "../../components/AboutComponents/BrandSection/BrandSection";
import FeatureSection from "../../components/AboutComponents/FeatureSection/FeatureSection";
import TeamLeadership from "../TeamPage/TeamLeadership";
import AwardSection from "../../components/AboutComponents/AwardSection/AwardSection";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import CompanyOverview from "../../components/About_Section/CompanyOverview";
import OurPerspective from "../../components/About_Section/OurPerspective";
import Vision from "../../components/About_Section/Vision";
import EngineeringPhilosophy from "../../components/About_Section/EngineeringPhilosophy";


const AboutPage: React.FC = () => {
  return (
    <Fragment>
      <div className='about-page inner-page'>
        <div className="body_wrap o-clip">
          <Header />
          <main>
           <PageTitle pageTitle="About Us" pagesub="About Us" />
            <CompanyOverview/>
            <OurPerspective/>
            <EngineeringPhilosophy/>
            <TeamLeadership />
            <Vision/>
          {/* <AboutSection /> */}
            <BrandSection />
            <FeatureSection />
            
              {/*  <AwardSection /> */}
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default AboutPage;
